var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",on:{"click":_vm.home}},[_c('img',{staticClass:"center",attrs:{"src":"/cloud.png","alt":"cloud"}}),_vm._v(" "),_c('div',{staticClass:"logo"},[_vm._v("Instashare")])])}
var staticRenderFns = []

export { render, staticRenderFns }